import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://68cfb6618915999646fb1f11b7da5cf0@o4507569897013248.ingest.us.sentry.io/4507569907105792",
  debug: false,
  environment: "production",
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});